import { createContext } from 'react';
import { MinimalTeaser } from '@src/interfaces';

const DiscoveryLinksContext = createContext<MinimalTeaser[]>([]);

export default DiscoveryLinksContext
